import React from 'react';
import { useDevTools } from '../AppContext';


export const DevOnlyFormFiller = ({
                                    children, formDataForQuickFill, setFormData,
                                  }) => {

  const { devMode } = useDevTools();
  const [refreshFormKey, setRefreshFormKey] = React.useState(0);
  const keyDownPressed = (event) => {
    if (event.altKey && event.code === 'KeyA') {
      setFormData(formDataForQuickFill);
      setRefreshFormKey((prev) => prev + 1);

    }
  };
  if (devMode) {
    return (<div key={refreshFormKey} onKeyDown={keyDownPressed}>
        {children}
      </div>);
  }
  return <>{children}</>;
};
